var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultSocketOptions, } from './framework/CommandSocket';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class SharpPnuh {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        this.framework = framework;
        // other class properties and constructor
        this.isMacAddressSpecified = false;
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.modelInfo = {
            '-LbTceAlthPJr4kwUy9U': { name: 'Universal (Professional / Aquos Board)', maxVolume: 100 },
            '-LbTeVVpTAcwzpVDeWeP': { name: '8M-B70AU', maxVolume: 100 },
            '-LbThnXE0-to8k4lhBa5': { name: 'PN-UH861', maxVolume: 100 },
            '-LbThnXE0-to8k4lhBa6': { name: 'PN-UH551', maxVolume: 100 },
            '-LbThnXE0-to8k4lhBa7': { name: 'PN-UH501', maxVolume: 100 },
            '-LbThnXE0-to8k4lhBa8': { name: 'PN-UH431', maxVolume: 100 },
            '-LbTj7ZtegrA9qH5WlHP': { name: 'PN-B501', maxVolume: 100 },
            '-LbTj7ZtegrA9qH5WlHQ': { name: 'PN-B401', maxVolume: 100 },
            '-LbTkx8f_ZvOXG4B7rAj': { name: 'PN-E603', maxVolume: 31 },
            '-LbTkx8f_ZvOXG4B7rAk': { name: 'PN-E703', maxVolume: 31 },
            '-LbTkx8f_ZvOXG4B7rAl': { name: 'PN-E803', maxVolume: 100 },
            '-LbTkx8f_ZvOXG4B7rAm': { name: 'PN-R903A', maxVolume: 100 },
            '-LbTqEKAYwBNVMq8uhaq': { name: 'PN-H701', maxVolume: 100 },
            '-LbTr11U3mdW9MbP3rsH': { name: 'PN-LE601', maxVolume: 31 },
            '-LbTr11U3mdW9MbP3rsI': { name: 'PN-LE701', maxVolume: 31 },
            '-LbTr11U3mdW9MbP3rsJ': { name: 'PN-LE801', maxVolume: 31 },
            '-LbTr11U3mdW9MbP3rsK': { name: 'PN-LE901', maxVolume: 31 },
            '-LbTsGmstS87Jkw7aqPB': { name: 'PN-M401', maxVolume: 100 },
            '-LbTsGmstS87Jkw7aqPC': { name: 'PN-M501', maxVolume: 100 },
            '-LbTsGmstS87Jkw7aqPD': { name: 'PN-R426', maxVolume: 31 },
            '-LbTsGmstS87Jkw7aqPE': { name: 'PN-R496', maxVolume: 31 },
            '-LbTsGmstS87Jkw7aqPF': { name: 'PN-R556', maxVolume: 31 },
            '-LbTsGmstS87Jkw7aqPG': { name: 'PN-R606', maxVolume: 31 },
            '-LbTsGmstS87Jkw7aqPH': { name: 'PN-R706', maxVolume: 31 },
            '-LbTtfjpBGYlDMwcRcvy': { name: 'PN-UH601', maxVolume: 100 },
            '-LbTtfjpBGYlDMwcRcvz': { name: 'PN-UH701', maxVolume: 100 },
            '-LbTuw6T_uV5GYPPk7Ig': { name: 'PN-V550A', maxVolume: 31 },
            '-LbTyhqmNNXF7UxTNDZ7': { name: 'PN-V600A', maxVolume: 31 },
            '-LbTyhqmNNXF7UxTNDZ8': { name: 'PN-V601A', maxVolume: 31 },
            '-LbTzOU-opNM42gNiKu8': { name: 'PN-V701', maxVolume: 31 },
            '-LbU-Ii6JtnqzCt0D_Sj': { name: 'PN-Y326', maxVolume: 31 },
            '-LbU-Ii6JtnqzCt0D_Sk': { name: 'PN-Y436', maxVolume: 31 },
            '-LbU-Ii6JtnqzCt0D_Sl': { name: 'PN-Y496', maxVolume: 31 },
            '-LbU-Ii6JtnqzCt0D_Sm': { name: 'PN-Y556', maxVolume: 31 },
            '-LzCvuGb8Z943L_C0sly': { name: 'PN-L651H', maxVolume: 31 },
            '-LzCw7sNo6bFnU-EqmrQ': { name: 'PN-L751H', maxVolume: 31 },
            '-LzCwD8YLHSL1MJYQrk_': { name: 'PN-L851H', maxVolume: 31 },
            '-MyyFw2cXw0D4NCxj0zL': { name: 'PN-C861H', maxVolume: 100 },
            '-MyyG-ZWESJCVHNIEoDU': { name: 'PN-C751H', maxVolume: 100 },
            '-NNmkhpAF5BKS6M6pIpj': { name: 'PN-U423', maxVolume: 100, sendTerminator: '\r\n' },
            '-NNmkzBGk5vGR5stASwz': { name: 'PN-U473', maxVolume: 100, sendTerminator: '\r\n' },
            '-NNml1alK8_CLTERma0e': { name: 'PN-U553', maxVolume: 100, sendTerminator: '\r\n' },
        };
        this.universalId = '-LbTceAlthPJr4kwUy9U';
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`POWR   ?`, /(\d+)|(OK|ERR|UNSELECTED)/i, // don't match on WAIT, wait for the OK
                tags, 
                // Occasionally the POWR   ? query takes 10 seconds to respond and ultimately
                // returns UNSELECTED and then the next query responds with ERR.
                { retryAttempts: 3 });
                // Response "0" is off and "1" is on. Respose "2" means "input signal waiting mode"
                // which seems to indicate the display is powered on, but not showing signal. We
                // consider that a valid power on state.
                // Some Sharp displays (e.g., PN-LC862), report power as ERR when powered off.
                if (match[1])
                    return match[1] !== '0';
                if (match[2] && match[2].toUpperCase() === 'ERR')
                    return false;
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                // Clear any pending busy timeouts that would set busy back to false. The power set
                // methods will set busy to true and manage the transition back to false.
                this.busyTimeout.clear();
                if (this.isMacAddressSpecified) {
                    if (this.socket.options.allowNoConnection) {
                        return this.setPowerWakeOnLanNetwork(power, tags);
                    }
                    else {
                        return this.setPowerWakeOnLanSerial(power, tags);
                    }
                }
                return this.setPowerSimple(power, tags);
            }),
            powerOffRestrictions: (config) => {
                return config.macAddress === undefined ? [] : ['get'];
            },
        };
        this.serial = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SRNO   ?`, /ERR|(.+)/i, tags);
                if (match[1])
                    return match[1];
                return 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`INPS   ?`, /(\d+)|ERR|WAIT/i, tags);
                if (match[1])
                    return match[1];
                return this.state.videoInput.value;
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                this.framework.suspendPolling(5000);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                const match = yield this.socket.send(`INPS${code.padStart(4, ' ')}`, /(OK)|ERR/i, // don't match on WAIT, wait for the OK
                tags, { sendTimeoutMs: 5000 } // some models take a while to respond to video switching
                );
                if (match[1])
                    return code;
                return this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOLM   ?`, /(\d+)|OK|WAIT|ERR/i, tags);
                if (match[1])
                    return parseInt(match[1], 10);
                return this.state.volume.value;
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`VOLM${volume.toString().padStart(4, '0')}`, /(\d+|OK|WAIT)|ERR/i, tags);
                if (match[1])
                    return volume;
                return this.state.volume.value;
            }),
            range: (config) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                return {
                    max: (_c = (_b = this.modelInfo[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : this.universalId]) === null || _b === void 0 ? void 0 : _b.maxVolume) !== null && _c !== void 0 ? _c : 100,
                    min: 0,
                    round: 1,
                };
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MUTE   ?`, /(\d+)|OK|WAIT|ERR/i, tags);
                if (match[1])
                    return match[1] === '1' ? true : false;
                return this.state.volumeMute.value;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MUTE${mute === true ? '   1' : '   0'}`, /(OK)|ERR|WAIT/, tags);
                return match[1] ? mute : this.state.volumeMute.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 2500, onePerInterval: true, controls: ['power', 'videoInput'] },
            { intervalMs: 5500, onePerInterval: true, controls: ['volume', 'volumeMute'] },
            {
                intervalMs: 5000,
                pollWhenDisconnected: true,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (!this.state.power.value &&
                        this.socket.options.allowNoConnection &&
                        this.socket.getState() !== 'connected') {
                        if (!this.framework.isReconnecting)
                            yield this.framework.reconnect();
                    }
                }),
            },
        ];
        if (this.socket.options.allowNoConnection) {
            // If the display is powered off externally (e.g., IR remote or third party controller),
            // then we will lose the socket connection. If this happens, we update the power state
            // to false.
            this.socket.onConnectionLost(() => {
                this.busyTimeout.clear();
                this.state.power.update(false, true);
            });
        }
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.state.busy.update(false);
            this.socket.options.sendTerminator =
                (_c = (_b = this.modelInfo[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '']) === null || _b === void 0 ? void 0 : _b.sendTerminator) !== null && _c !== void 0 ? _c : '\r';
            this.isMacAddressSpecified = config.macAddress !== undefined;
            if (this.isMacAddressSpecified && config.port === undefined) {
                this.log.error(`mac address configured for wake on lan, but no port specified`);
            }
            if (config.macAddress !== undefined) {
                // The mac address is specified, so we can't query the power if the device is powered
                // off. The power is initialized to false, but we need to query it if we can when we
                // first connect.
                if (!(this.socket.port === 10008 || this.socket.port === 8888) ||
                    this.socket.state === 'connected') {
                    this.state.power.update(yield this.power.get(['power.get']));
                }
            }
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials, config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.options.sendTerminator =
                (_c = (_b = this.modelInfo[(_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : '']) === null || _b === void 0 ? void 0 : _b.sendTerminator) !== null && _c !== void 0 ? _c : '\r';
            const initializerStepsNetwork = [
                {
                    errorCode: 'verifyFailed',
                    unterminatedRegExp: /Login:/i,
                    next: /Login:/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.username) !== null && _a !== void 0 ? _a : '';
                    },
                    unterminatedRegExp: /Password:/i,
                    next: /Password:/i,
                    fail: /Wrong username or password|Login incorrect/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.password) !== null && _a !== void 0 ? _a : '';
                    },
                    unterminatedRegExp: /New password:/i,
                    succeed: /OK/,
                    next: /New password:/i,
                    fail: /Login incorrect/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.password) !== null && _a !== void 0 ? _a : '';
                    },
                    unterminatedRegExp: /Retype new password:/i,
                    next: /Retype new password:/i,
                },
                {
                    errorCode: 'authFailed',
                    send: (cred) => {
                        var _a;
                        return (_a = cred.password) !== null && _a !== void 0 ? _a : '';
                    },
                    succeed: /OK/,
                    fail: /Login incorrect/i,
                },
            ];
            const initializerStepsRS232 = [
                {
                    errorCode: 'verifyFailed',
                    send: 'POWR   ?',
                    next: /OK|\d+|ERR|WAIT|UNSELECTED/i,
                },
            ];
            // If the socket is connected (the display is powered on), confirm connection.
            if (this.socket.state === 'connected') {
                let status = 'verifyFailed';
                // 4P series doesn't have the login steps even with a network connection, so we must run
                // through the RS232 initializer steps too.
                const initializerSteps = [initializerStepsNetwork, initializerStepsRS232];
                let lastStatus = 'verifyFailed';
                for (const step of initializerSteps) {
                    status = yield CommandSocketInitializer.initialize(this.socket, step, credentials);
                    if (status === 'connected') {
                        return status;
                    }
                    else if (status === 'authFailed') {
                        lastStatus = status; // remember network connection failure
                    }
                }
                // If we didn't verify connection over RS232 and failed auth over the network, return
                // failed auth status so user knows to correct login credentials
                return lastStatus;
            }
            else if (this.socket.options.allowNoConnection) {
                return 'connected';
            }
            return 'connectFailed';
        });
    }
    // other class methods
    setPowerSimple(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state.busy.update(true);
            this.state.power.update(power);
            let gotOkResponse = false;
            try {
                // Sometimes the display responds with UNSELECTED to a power set command. If this
                // happens, we should just resend the power set command. We try several times before
                // giving up.
                //
                // Also, since we may be sending multiple commands, we suspend polling so no polls
                // happen between the power set commands which could cause the power state to appear
                // to bounce.
                this.framework.suspendPolling();
                for (let i = 0; i < 3; i++) {
                    const match = yield this.socket.send(`POWR${power ? '   1' : '   0'}`, /(OK|UNSELECTED|ERR)/i, // don't match on WAIT, wait for the OK
                    tags, { sendTimeoutMs: power ? 18000 : 4000 });
                    if (match[1].toUpperCase() === 'OK') {
                        gotOkResponse = true;
                        break;
                    }
                    yield this.timeouts.delay(3000);
                }
                if (power) {
                    // set the backlight on for the PN-LC862
                    yield this.socket.sendAsync(`BOMD   1`, ['set.backlight']);
                }
            }
            catch (_a) { }
            // Resume polling, but with a short wait. Sometimes the display sends the previous power
            // value in repsonse to power queries immediately after changing state. To avoid a "bounce"
            // in the reported value, we delay polling for a short time.
            // Increase polling suspension since there's a 5 second countdown timer on the LC862 before.
            this.framework.suspendPolling(10000);
            if (gotOkResponse) {
                this.framework.suspendPolling(10000);
            }
            else {
                this.framework.resume();
            }
            this.state.busy.update(false);
            this.state.power.update(power);
            return this.state.power.value;
        });
    }
    setPowerWakeOnLanNetwork(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.framework.suspendPolling(6000);
            this.socket.removeCommands('poll');
            if (power) {
                // If the socket is still connected, send a power command.
                if (this.socket.state === 'connected') {
                    yield this.socket.sendAsync(`POWR   1`, tags);
                    // Try to set the backlight on for PN-LC862.
                    yield this.socket.sendAsync(`BOMD   1`, ['set.backlight']);
                }
                // For direct Ethernet connections where the socket connection is lost when the display
                // is powered off, we first uppdate the power state so the UI will reflect that the
                // power is on, then we block while sending a wake on lan request and attempting to
                // reconnect to the display.
                this.state.busy.update(true);
                // Update power with a short delay so that framework.reconnect gets called first. This
                // tells StateBridge we are disconnected so it doesn't change phase back to configuring
                // to query the controls with power off restrictions when it sees that the power is
                // back on.
                this.timeouts.set(() => this.state.power.update(power), 100);
                yield this.framework.reconnect({
                    attemptDelayMs: 1000,
                    initialDelayMs: 0,
                    numAttempts: 8,
                    onBeforeReconnect: () => __awaiter(this, void 0, void 0, function* () {
                        return this.framework.sendWakeOnLan();
                    }),
                });
                // When updating the busy state, we must use notifyIfUnchanged = true. This is because
                // the driver reconnects as part of powering on, and reconnecting resets all the states.
                // Without notifyIfUnchanged = true, the busy = false notification won't get sent.
                this.state.busy.update(false, true);
                return this.socket.state === 'connected';
            }
            else {
                return this.setPowerSimple(power, tags);
            }
        });
    }
    setPowerWakeOnLanSerial(power, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            this.framework.suspendPolling(6000);
            this.socket.removeCommands('poll');
            if (power) {
                // If the socket is still connected, send a power command.
                if (this.socket.state === 'connected') {
                    yield this.socket.sendAsync(`POWR   1`, tags);
                    // Try to set the backlight on for PN-LC862.
                    yield this.socket.sendAsync(`BOMD   1`, ['set.backlight']);
                }
                // For serial connections where the display is unresponsive when powered off, first we
                // update the power state so the UI will reflect that the power is on, then we block
                // while sending a wake on lan request, then we continue blocking while sending some
                // power requests to confirm that the power is on, finally we return the new power
                // state.
                this.state.busy.update(true);
                // Update power with a short delay so that framework.reconnect gets called first. This
                // tells StateBridge we are disconnected so it doesn't change phase back to configuring
                // to query the controls with power off restrictions when it sees that the power is
                // back on.
                this.timeouts.set(() => this.state.power.update(power), 100);
                let newPower = false;
                for (let i = 0; i < 4; i++) {
                    this.framework.suspendPolling(6000);
                    yield this.framework.sendWakeOnLan();
                    try {
                        const match = yield this.socket.send(`POWR   ?`, /(\d+)|OK|ERR/i, [
                            'power.get',
                        ]);
                        newPower = match[1] === '1';
                        break;
                    }
                    catch (_a) { }
                }
                this.state.busy.update(false);
                return newPower;
            }
            else {
                return this.setPowerSimple(power, tags);
            }
        });
    }
}
// static properties
SharpPnuh.driverType = 'socketDriver';
SharpPnuh.key = '-LbTg4Fgml39SETg_xZM';
SharpPnuh.socketOptions = (config) => {
    const baseSocketOptions = {
        commandExtractor: {
            terminators: ['\r', '\n'],
        },
        sendTerminator: '\r',
    };
    const hasMacAddress = config.macAddress !== undefined;
    if (config.port === undefined) {
        return [
            Object.assign(Object.assign({}, baseSocketOptions), { port: 10008, allowNoConnection: hasMacAddress }),
            Object.assign(Object.assign({}, baseSocketOptions), { port: 4999, idleTimeoutMs: hasMacAddress ? 0 : defaultSocketOptions.idleTimeoutMs, allowNoConnection: false }),
            Object.assign(Object.assign({}, baseSocketOptions), { port: 8888, allowNoConnection: hasMacAddress }),
        ];
    }
    // Assume port 10008 or 8888 are direct Ethernet connections to the device and anything else
    // is via an Ethernet to serial converter.
    return [
        Object.assign(Object.assign({}, baseSocketOptions), { port: config.port, idleTimeoutMs: hasMacAddress && !(config.port === 10008 || config.port === 8888)
                ? 0
                : defaultSocketOptions.idleTimeoutMs, allowNoConnection: hasMacAddress && (config.port === 10008 || config.port === 8888) }),
    ];
};
